module.exports = __webpack_public_path__ + "static/media/developer.37c3a1c7.png";